module.exports = __webpack_public_path__ + "static/media/head-side-headphones.b6f482b7.svg";